
  import { FilterEntry } from '@/entities/filter/model';
  import { CheckboxField } from '@/ui/components/form/CheckboxField';
  import { TagField } from '@/ui/components/form/TagField';
  import { updateMultiple } from '@/ui/queryState';
  import { PaginationResetCallback, SelectOptions } from '@/ui/types';
  import { computed, defineComponent, ref, Ref } from 'vue';

  interface Props {
    value: Ref<number[]>;
    users: Ref<FilterEntry[]>;
    reset: PaginationResetCallback;
  }

  export default defineComponent<Props>({
    components: { CheckboxField, TagField },
    props: ['value', 'users', 'reset'],
    setup(props) {
      const includeDeleted = ref(false);

      const onInput = (v: number[]) => updateMultiple(() => {
        props.reset();
        props.value.value = v;
      }, true);

      const updateIncludeDeleted = (v: boolean) => {
        includeDeleted.value = v;
      };

      const filteredOptions = computed<SelectOptions>(
        () => {
          return (props.users.value || [])
            .filter(user => includeDeleted.value || !user.is_deleted || props.value.value.includes(user.id as number))
            .map(user => ({
              value: user.id as number,
              label: user.title,
            }));
        },
      );

      return {
        onInput,
        includeDeleted,
        updateIncludeDeleted,
        filteredOptions,
      };
    },
  });
